/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Tourhelp_MinutesInputs */

const en_tourhelp_minutes = /** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
};

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const ar_tourhelp_minutes = en_tourhelp_minutes;

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const he_tourhelp_minutes = en_tourhelp_minutes;

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const ur_tourhelp_minutes = en_tourhelp_minutes;

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const es_tourhelp_minutes = en_tourhelp_minutes;

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const fr_tourhelp_minutes = en_tourhelp_minutes;

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const de_tourhelp_minutes = en_tourhelp_minutes;

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const pt_tourhelp_minutes = en_tourhelp_minutes;

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const hi_tourhelp_minutes = en_tourhelp_minutes;

/** @type {(inputs: Tourhelp_MinutesInputs) => LocalizedString} */
const bn_tourhelp_minutes = en_tourhelp_minutes;

/**
* | output |
* | --- |
* | "{minutes} min" |
*
* @param {Tourhelp_MinutesInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const tourhelp_minutes = /** @type {((inputs: Tourhelp_MinutesInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tourhelp_MinutesInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_tourhelp_minutes(inputs)
	if (locale === "he") return he_tourhelp_minutes(inputs)
	if (locale === "ur") return ur_tourhelp_minutes(inputs)
	if (locale === "es") return es_tourhelp_minutes(inputs)
	if (locale === "fr") return fr_tourhelp_minutes(inputs)
	if (locale === "de") return de_tourhelp_minutes(inputs)
	if (locale === "pt") return pt_tourhelp_minutes(inputs)
	if (locale === "hi") return hi_tourhelp_minutes(inputs)
	if (locale === "bn") return bn_tourhelp_minutes(inputs)
	return en_tourhelp_minutes(inputs)
});